import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />} />

      {/* SERVICES */}
      <Route path="/services/*" element={<Layout />} />

      {/* TEAM */}
      <Route path="/team/*" element={<Layout />} />

      {/* BLOGS */}
      <Route path="/blogs/*" element={<Layout />} />

      {/* FAQ */}
      <Route path="/faq/*" element={<Layout />} />

      <Route path="/philosophy/*" element={<Layout />} />

      <Route path="/contact/*" element={<Layout />} />
    </Routes>
  );
}
